import { css, styled } from 'styled-components';

import { H3 } from '#/components/Text/H3';
import { colors } from '#/theme/theme';

export const ListingViewSectionHolder = styled.div<{ $noBorderTop: boolean }>`
  margin-top: 24px;

  ${(props) =>
    !props.$noBorderTop &&
    css`
      border-top: solid 1px ${colors.selectionGrey};
      padding-top: 24px;
    `};
`;

export const ListingViewSectionTitle = styled(H3)`
  margin-bottom: 24px;
`;
